import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'shalala';
import { Dropdown, DropdownButton } from 'react-bootstrap';

import { useStore } from '../../../store';
import SearchInput from '../../../facturotopia/search-input/SearchInput';
import CalendarDateRangePicker from '../../../facturotopia/calendar-date-range-picker/CalendarDateRangePicker';

class DashboardClientesSearch extends Component {
  state = {
    index: '',
  };

  constructor(props) {
    super(props);

    const { from: asFrom, to: asTo } = this.props.pagination;

    const from = !!asFrom ? moment(asFrom) : moment().subtract(2, 'months');
    const to = !!asTo ? moment(asTo) : moment();

    this.state = {
      from: from.toDate(),
      to: to.toDate(),
    };
  }

  handleOnKeywordChange = (keyword) => {
    const { filters } = this.props.pagination;

    this.props.paginate({
      ...filters,
      search: keyword,
      field: this.state.index,
    });
  };

  handleOnSearchClear = () => {
    this.handleOnKeywordChange('');
  };

  handleOnDateChange = (date) => {
    const { filters } = this.props.pagination;
    const from = moment(date[0]);
    const to = moment(date[1]);

    this.props.paginate({
      ...filters,
      from: from.format('YYYY-MM-DD'),
      to: to.format('yyyy-MM-DD'),
    });
  };

  handleOnSelectIndex = (name, event) => {
    const { id } = event.target;

    this.setState({
      index: id,
    });
  };

  getOmnisearchLegend = () => {
    const { index } = this.state;

    let legend = 'Cliente';

    switch (index) {
      case 'razon_social':
        legend = 'Razón Social';
        break;
      case 'nombre_comercial':
        legend = 'Nombre Comercial';
        break;
      case 'rfc':
        legend = 'RFC';
        break;
      case 'email':
        legend = 'Email';
        break;
      case 'contacto':
        legend = 'Contacto';
        break;
      case 'telefono':
        legend = 'Teléfono';
        break;
      default:
        break;
    }

    return legend;
  };

  render() {
    const { from, to } = this.state;
    const {
      filters: { search },
    } = this.props;

    return (
      <div className="d-flex flex-column flex-sm-row">
        <div className="pr-2 pb-2">
          <CalendarDateRangePicker
            value={[from, to]}
            onDateChange={this.handleOnDateChange}
          />
        </div>
        <div className="flex-fill search-container">
          <SearchInput
            onKeywordChange={this.handleOnKeywordChange}
            onClear={this.handleOnSearchClear}
            value={search}
          >
            <DropdownButton
              variant="outline-secondary"
              title={this.getOmnisearchLegend()}
              id="search-index"
              onSelect={this.handleOnSelectIndex}
            >
              <Dropdown.Item id="">Sin filtro</Dropdown.Item>

              <Dropdown.Divider />

              <Dropdown.Item id="razon_social">Razón Social</Dropdown.Item>
              <Dropdown.Item id="nombre_comercial">Nombre Comercial</Dropdown.Item>
              <Dropdown.Item id="rfc">RFC</Dropdown.Item>
              <Dropdown.Item id="email">Email</Dropdown.Item>
              <Dropdown.Item id="contacto">Contacto</Dropdown.Item>
              <Dropdown.Item id="telefono">Teléfono</Dropdown.Item>
            </DropdownButton>
          </SearchInput>
        </div>
      </div>
    );
  }
}

const mapState = (store) => {
  return store.admin.dashboard.list;
};

const mapActions = (actions) => {
  return {
    paginate: actions.admin.dashboard.list.paginate,
  };
};

export default connect(useStore, mapState, mapActions)(DashboardClientesSearch);
